import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux'
import KeywordSearch from './dev/KeywordSearch'
import CountrySearch from './dev/CountrySearch';
import CategorySearch from './dev/CategorySearch';
import VideoSliderBar from './VideoSliderBar';

class VideoSearch extends Component {
    state = {
        urlArgs: {
            keyword	: '',
            country: '',
            category: '',
            subscriberCountFrom: 10000, subscriberCountTo: 2000000,
            viewCountFrom: 10000, viewCountTo: 2000000,
            engageRateFrom: 0, engageRateTo: 7,
        },
        keyword: '',
    }
    componentDidMount = () => this.urlEncode()
    heyPleaseUpgrade = () => {
        this.props.dispatch({ 
            type: 'togglePaymentField', 
            isPaymentGuideActive: true,
            paymentGuideMinPlan: "Brand",
        })
        return
    }
    urlEncode = () => {
        const { urlArgs, keyword } = this.state;
        let url = Object.entries(urlArgs)
            .map(pairs => {
                const [key, value] = pairs.map(encodeURIComponent);
                return `${key}=${value}`;
            })
            .join("&");
        const { REACT_APP_URI = '/' } = process.env
        url = `${REACT_APP_URI}/Video/?` + url
        this.props.dispatch({
            type: 'CHANGE_VIDEOLURL',
            videoUrl: url,
        })
        this.props.dispatch({
            type: 'CHANGE_VIDEOLKEYWORD',
            videoKeyword: keyword,
        })
    }
    SetSliderRange = (name) => ([from, to]) => {
        const {user:{ plan, auth}} = this.props
        if(auth === "notSignIn") {
            this.props.dispatch({ type: 'toggleUserField', condition: 'signIn'})
            return
        }
        if(plan !== "Brand" && plan !== "Agency") {
            this.heyPleaseUpgrade()
            return
        }
        this.setState({
            urlArgs: {
                ...this.state.urlArgs,
                [name + `From`]: from,
                [name + `To`]: to,
            },
        }, () => {
            this.urlEncode()
        })
        return [from, to]
    }
    keywordInput = e => this.setState({ keyword: e.target.value });
    keywordSubmit = e => {
        const {user:{ plan, auth}} = this.props
        if(auth === "notSignIn") {
            this.props.dispatch({ type: 'toggleUserField', condition: 'signIn'})
            return
        }
        if(plan !== "Brand" && plan !== "Agency") {
            this.heyPleaseUpgrade()
            return
        }
        const { keyword } = this.state
            this.setState({
                urlArgs: {
                    ...this.state.urlArgs,
                    keyword: keyword
                },
            }, () => {
                this.urlEncode()
            })
    }
    countrySelect = ({ value }) => {
        const {user:{ plan, auth}} = this.props
        if(auth === "notSignIn") {
            this.props.dispatch({ type: 'toggleUserField', condition: 'signIn'})
            return
        }
        if(plan !== "Brand" && plan !== "Agency") {
            this.heyPleaseUpgrade()
            return
        }
        this.setState({ urlArgs: { ...this.state.urlArgs, country: value }, }, () => { this.urlEncode() })
    }
    categorySelect = ({ value }) => {
        const {user:{ plan, auth}} = this.props
        if(auth === "notSignIn") {
            this.props.dispatch({ type: 'toggleUserField', condition: 'signIn'})
            return
        }
        if(plan !== "Brand" && plan !== "Agency") {
            this.heyPleaseUpgrade()
            return
        }
        this.setState({ urlArgs: { ...this.state.urlArgs, category: value }, }, () => { this.urlEncode() })
    }
    render() {
        const { SetSliderRange, keywordInput, keywordSubmit, countrySelect, categorySelect } = this
        const { urlArgs, urlArgs: { country, category }, keyword } = this.state
        const {messages, tour:{isInfoListTourActive}} = this.props
        return (
            <VideoSearchWrap>
                <TopField>
                    <KeywordSearch tourId="user_tour_infolist_6" id={'ga_video_search_input'} 
                        keyword={isInfoListTourActive ? "makeup" : keyword} 
                        keywordInput={keywordInput} 
                        keywordSubmit={keywordSubmit} 
                        keywordType={messages.info_list_video_search_tip} />
                    <Wrap>
                        <CountrySearch country={country} countrySelect={countrySelect} />
                        <CategorySearch category={category} categorySelect={categorySelect} />
                    </Wrap>
                </TopField>
                <VideoSliderBar SetSliderRange={SetSliderRange} urlArgs={urlArgs} />
            </VideoSearchWrap>
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.User,
        infoList: state.InfoList,
        messages: state.Messages,
        tour: state.Tour,
    }
}
export default connect(mapStateToProps)(VideoSearch);

const VideoSearchWrap = styled.div`
    display: flex;
    flex-direction: column;
`
const TopField = styled.div`
    grid-area: TopField;
    width: 100%;
    padding: 20px;
    background-color: #fff;
    border-bottom: 1px solid #e6e6e6;
`
const Wrap = styled.div`
    display: flex;
`


// WEBPACK FOOTER //
// ./src/InfoList/Search/VideoSearch.js